export default function Worker_fn() {
  return new Worker("/dist/8.2.6.136/" + "XhrWorker.vbworker.min.worker.js");
}
